// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Unscramble from "../Unscramble/index.js";
var SerializedMap = function (x) {
    return x;
};
var AsJSONKeyString = /* #__PURE__ */ (function () {
    function AsJSONKeyString(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    AsJSONKeyString.create = function (value0) {
        return function (value1) {
            return new AsJSONKeyString(value0, value1);
        };
    };
    return AsJSONKeyString;
})();
var AsJSONKeyValue = /* #__PURE__ */ (function () {
    function AsJSONKeyValue(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    AsJSONKeyValue.create = function (value0) {
        return function (value1) {
            return new AsJSONKeyValue(value0, value1);
        };
    };
    return AsJSONKeyValue;
})();
var asJSONKeyMaybe = function (dictEncode) {
    return function (dictDecode) {
        return {
            asJSONKey: new AsJSONKeyValue(Foreign_Generic_Class.encode(Foreign_Generic_Class.maybeEncode(dictEncode)), Foreign_Generic_Class.decode(Foreign_Generic_Class.maybeDecode(dictDecode)))
        };
    };
};
var udecodeMap = function (dictOrd) {
    return function (dictFromJSONKey) {
        return function (dictDecode) {
            return Unscramble.decodeMap(dictFromJSONKey)(dictOrd)(dictDecode);
        };
    };
};
var showMap = function (dictShow) {
    return function (dictShow1) {
        return Data_Map_Internal.showMap(dictShow)(dictShow1);
    };
};
var semigroupMap = function (dictOrd) {
    return {
        append: function (v) {
            return function (v1) {
                return Data_Map_Internal.union(dictOrd)(v)(v1);
            };
        }
    };
};
var ordMap = function (dictOrd) {
    return function (dictOrd1) {
        return Data_Map_Internal.ordMap(dictOrd)(dictOrd1);
    };
};
var newtypeMap = {
    Coercible0: function () {
        return undefined;
    }
};
var monoidMap = function (dictOrd) {
    return {
        mempty: Data_Map_Internal.empty,
        Semigroup0: function () {
            return semigroupMap(dictOrd);
        }
    };
};
var functorMap = Data_Map_Internal.functorMap;
var fromSerializedMap = /* #__PURE__ */ Data_Newtype.unwrap();
var fromJSONKeyMap = function (dictOrd) {
    return function (dictFromJSONKey) {
        return function (dictDecode) {
            return {
                fromJSONKey: Unscramble.defaultFromJSONKeyValue(udecodeMap(dictOrd)(dictFromJSONKey)(dictDecode))
            };
        };
    };
};
var foldableWithIndexMap = Data_Map_Internal.foldableWithIndexMap;
var foldableMap = Data_Map_Internal.foldableMap;
var eqMap = function (dictEq) {
    return function (dictEq1) {
        return Data_Map_Internal.eqMap(dictEq)(dictEq1);
    };
};
var asJSONKeyString = /* #__PURE__ */ (function () {
    return {
        asJSONKey: new AsJSONKeyString(Control_Category.identity(Control_Category.categoryFn), Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity)))
    };
})();
var asJSONKeyMap = function (dictOrd) {
    return function (dictAsJSONKey) {
        return function (dictEncode) {
            return function (dictDecode) {
                return {
                    asJSONKey: new AsJSONKeyValue(Foreign_Generic_Class.encode(dictEncode), Foreign_Generic_Class.decode(dictDecode))
                };
            };
        };
    };
};
var asJSONKey = function (dict) {
    return dict.asJSONKey;
};
var decodeMap = function (dictOrd) {
    return function (dictAsJSONKey) {
        return function (dictDecode) {
            return function (dictGenericDecodeArgs) {
                return {
                    decode: function (f) {
                        var v = asJSONKey(dictAsJSONKey);
                        if (v instanceof AsJSONKeyString) {
                            return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Generic_Class.decode(Foreign_Generic_Class.objectDecode(dictDecode))(f))(function (obj) {
                                var kvs = Foreign_Object.toUnfoldable(Data_Unfoldable.unfoldableArray)(obj);
                                return Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))((function () {
                                    var $63 = Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray);
                                    return function ($64) {
                                        return SerializedMap($63($64));
                                    };
                                })())(Data_Traversable.traverse(Data_Traversable.traversableArray)(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(function (v1) {
                                    return Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Function.flip(Data_Tuple.Tuple.create)(v1.value1))(v.value1(v1.value0));
                                })(kvs));
                            });
                        };
                        if (v instanceof AsJSONKeyValue) {
                            return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Generic_Class.decode(Foreign_Generic_Class.arrayDecode(Data_Tuple_T2.decodeT2(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.foreignDecode)))(dictGenericDecodeArgs)))(f))(function (kvs) {
                                return Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))((function () {
                                    var $65 = Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray);
                                    return function ($66) {
                                        return SerializedMap($65($66));
                                    };
                                })())(Data_Traversable.traverse(Data_Traversable.traversableArray)(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(function (v1) {
                                    return Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Function.flip(Data_Tuple.Tuple.create)(v1.value1))(v.value1(v1.value0));
                                })(kvs));
                            });
                        };
                        throw new Error("Failed pattern match at Data.Map.Serialized (line 61, column 5 - line 68, column 105): " + [ v.constructor.name ]);
                    }
                };
            };
        };
    };
};
var encodeMap = function (dictAsJSONKey) {
    return function (dictEncode) {
        return function (dictGenericEncodeArgs) {
            return {
                encode: function (v) {
                    var kvs = Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(v);
                    var v1 = asJSONKey(dictAsJSONKey);
                    if (v1 instanceof AsJSONKeyString) {
                        return Foreign_Generic_Class.encode(Foreign_Generic_Class.objectEncode(dictEncode))(Foreign_Object.fromFoldable(Data_Foldable.foldableArray)(Data_Functor.map(Data_Functor.functorArray)(function (v2) {
                            return new Data_Tuple.Tuple(v1.value0(v2.value0), v2.value1);
                        })(kvs)));
                    };
                    if (v1 instanceof AsJSONKeyValue) {
                        return Foreign_Generic_Class.encode(Foreign_Generic_Class.arrayEncode(Data_Tuple_T2.encodeT2(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.foreignEncode)))(dictGenericEncodeArgs)))(Data_Functor.map(Data_Functor.functorArray)(function (v2) {
                            return new Data_Tuple_T2.T2(v1.value0(v2.value0), v2.value1);
                        })(kvs));
                    };
                    throw new Error("Failed pattern match at Data.Map.Serialized (line 55, column 7 - line 57, column 108): " + [ v1.constructor.name ]);
                }
            };
        };
    };
};
export {
    SerializedMap,
    asJSONKey,
    AsJSONKeyString,
    AsJSONKeyValue,
    fromSerializedMap,
    newtypeMap,
    eqMap,
    ordMap,
    showMap,
    semigroupMap,
    monoidMap,
    functorMap,
    foldableMap,
    udecodeMap,
    foldableWithIndexMap,
    asJSONKeyString,
    asJSONKeyMap,
    asJSONKeyMaybe,
    encodeMap,
    decodeMap,
    fromJSONKeyMap
};
//# sourceMappingURL=index.js.map
